import { IconButton, IconButtonProps } from '@air/zephyr';

export interface AgencyCardSocialIconButtonProps extends Pick<IconButtonProps, 'children' | 'icon' | 'tx'> {
  href?: string | null;
}

export const AgencyCardSocialIconButton = ({ children, href, icon, tx }: AgencyCardSocialIconButtonProps) => {
  if (!href) return null;

  return (
    <IconButton
      as="a"
      href={href}
      icon={icon}
      rel="noopener noreferrer"
      target="_blank"
      tx={{ mr: 4, ...tx }}
      variant="button-ghost-grey"
    >
      {children}
    </IconButton>
  );
};
